import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=2ed05e90&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed05e90')) {
      api.createRecord('2ed05e90', component.options)
    } else {
      api.reload('2ed05e90', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=2ed05e90&", function () {
      api.rerender('2ed05e90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wVzP1w2Dp2uC/JS/comp/CurrentYear.vue"
export default component.exports